import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { submitForm } from '../../../store/actions/ProductActions';

const TableProductSlNo = ({ row, col, value }) => {
  const dispatch = useDispatch();

  const token = useSelector(state => state?.auth?.token);

  const handleRecommend = () => {
    dispatch(submitForm('editProduct', token, { isRecommended: !row?.isRecommended }, row?._id));
  };

  return (
    <>
      {value}{' '}
      <IconButton onClick={handleRecommend}>
        {row?.isRecommended ? <StarIcon /> : <StarBorderIcon />}
      </IconButton>
    </>
  );
};

export default TableProductSlNo;
